import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef } from 'react';
import styled from 'styled-components';
import { F as FileUploadContext } from '../FileUploadContext-CI9_em1Z.js';
import { F as FileUploadDropZone$1 } from './FileUploadDropZone-CSJg0YmB.js';

const Input = /*#__PURE__*/styled('input').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1nc7hfm-0"
})(["display:none;"]);
const FileUploadDropZone = ({
  accept,
  children,
  description,
  disabled,
  dropzoneId,
  heading,
  errorText,
  fullWidth,
  inputId,
  multiple,
  name,
  onChange,
  onCloseAlert,
  ...rest
}) => {
  const inputRef = useRef(null);
  const handleOnChange = event => {
    const fileList = event.type === 'drop' ? event.dataTransfer.files : event.target.files;
    const fileNames = [...fileList].map(file => file);
    onChange === null || onChange === void 0 || onChange(event, fileNames);
  };
  return /*#__PURE__*/React__default.createElement(FileUploadContext.Provider, {
    value: {
      description,
      disabled,
      errorText,
      fullWidth,
      inputId,
      inputRef,
      onCloseAlert
    }
  }, /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, accept && {
    accept: accept.toString()
  }, {
    "aria-hidden": "true",
    id: inputId,
    name: name,
    tabIndex: -1,
    type: "file",
    onChange: handleOnChange,
    ref: inputRef,
    multiple: multiple
  })), /*#__PURE__*/React__default.createElement(FileUploadDropZone$1, {
    heading: heading,
    dropzoneId: dropzoneId,
    onDrop: handleOnChange
  }));
};

export { FileUploadDropZone as F };
//# sourceMappingURL=index-CuWHwj8G.js.map
